<template>
  <div class="table_container">
    <div class="table-btn" style="margin: 24px 0 12px 0">
      <el-button
        v-if="$route.query.operateType !== '查看'"
        :disabled="tableData.length >= 15"
        type="primary"
        size="small"
        @click="handleAdd()"
        >添加</el-button
      >
    </div>
    <el-table
      ref="tableRef"
      highlight-current-row
      :border="true"
      :data="tableData"
      :header-cell-style="{
        background: '#EFEFEF',
        color: '#000',
        borderColor: '#dcdfe6'
      }"
      :cell-class-name="cellClassName"
      @cell-click="handleCellClick"
    >
      <!-- 序号 -->
      <el-table-column label="序号" width="50px" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <!-- 金融服务名称/提供商 -->
      <el-table-column
        prop="name"
        label="金融服务名称/提供商"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="editField === 'name' && editIndex === scope.$index"
            id="focusRef"
            v-model="scope.row.name"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.name }}
          </div>
        </template>
      </el-table-column>
      <!-- 首付比例 -->
      <el-table-column
        prop="downPaymentRatio"
        label="首付比例"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="
              editField === 'downPaymentRatio' && editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.downPaymentRatio"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.downPaymentRatio }}
          </div>
        </template>
      </el-table-column>
      <!-- 贷款利率 -->
      <el-table-column
        prop="loanInterestRate"
        label="贷款利率"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="
              editField === 'loanInterestRate' && editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.loanInterestRate"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.loanInterestRate }}
          </div>
        </template>
      </el-table-column>
      <!-- 最长贷款周期 -->
      <el-table-column
        prop="longestLoanCycle"
        label="最长贷款周期"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="
              editField === 'longestLoanCycle' && editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.longestLoanCycle"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.longestLoanCycle }}
          </div>
        </template>
      </el-table-column>
      <!-- 审批通过率 -->
      <el-table-column
        prop="approvalPassRate"
        label="审批通过率"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="
              editField === 'approvalPassRate' && editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.approvalPassRate"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.approvalPassRate }}
          </div>
        </template>
      </el-table-column>
      <!-- 有无限制/担保条件/保险条件 -->
      <el-table-column
        prop="conditionRestrictions"
        label="有无限制/担保条件/保险条件"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-select
            v-if="
              editField === 'conditionRestrictions' &&
                editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.conditionRestrictions"
            placeholder="请选择"
            filterable
            clearable
            size="mini"
            automatic-dropdown
            @visible-change="visibleChange"
            @change="confirmEdit"
          >
            <el-option label="有" value="有"></el-option>
            <el-option label="无" value="无"></el-option>
          </el-select>
          <div v-else>
            {{ scope.row.conditionRestrictions }}
          </div>
        </template>
      </el-table-column>
      <!-- 限制/担保/保险条件说明 -->
      <el-table-column
        prop="conditionRestrictionsRemark"
        label="限制/担保/保险条件说明"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="
              editField === 'conditionRestrictionsRemark' &&
                editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.conditionRestrictionsRemark"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.conditionRestrictionsRemark }}
          </div>
        </template>
      </el-table-column>
      <!-- 备注 -->
      <el-table-column
        prop="remark"
        label="备注"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="editField === 'remark' && editIndex === scope.$index"
            id="focusRef"
            v-model="scope.row.remark"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.remark }}
          </div>
        </template>
      </el-table-column>
      <!-- 操作 -->
      <el-table-column
        v-if="$route.query.operateType !== '查看'"
        label="操作"
        align="center"
        width="90px"
        fixed="right"
      >
        <template slot-scope="scope">
          <!-- 删除 -->
          <el-button size="mini" type="text" @click="handleDelete(scope.$index)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { addOrUpdateFinanceEnvironmentChangeApi } from "@/api/saleTaskCollection";

export default {
  data() {
    return {
      tableData: [],
      editField: "", // 编辑单元格
      editIndex: -1 // 编辑行索引
    };
  },
  methods: {
    init(data) {
      this.tableData = data || [];
    },
    // 添加
    handleAdd() {
      this.tableData.push({
        name: "",
        downPaymentRatio: "",
        loanInterestRate: "",
        longestLoanCycle: "",
        approvalPassRate: "",
        conditionRestrictions: "",
        conditionRestrictionsRemark: "",
        remark: ""
      });
    },
    // 删除
    handleDelete(index) {
      this.tableData.splice(index, 1);
    },
    // 获取单元格索引
    cellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column = { ...column, index: columnIndex };
    },
    // 点击单元格
    handleCellClick(row, column) {
      this.handleColumn(column.property, row.index ?? -1);
      this.tableData[row.index][column.property] =
        this.tableData[row.index][column.property] ?? undefined;
    },
    // 点击单元格编辑
    handleColumn(field, index) {
      if (this.$route.query.operateType === "查看") return;
      this.editField = field;
      this.editIndex = index ?? -1;
      this.$nextTick(() => {
        document.querySelector("#focusRef")?.focus();
        document.querySelector("#focusRef .el-input__inner")?.focus();
      });
    },
    // 确认编辑
    confirmEdit() {
      this.editField = "";
      this.editIndex = -1;
    },
    // el-select 显示隐藏选项框时触发
    visibleChange(visible) {
      if (!visible) {
        this.confirmEdit();
      }
    },
    // 保存
    async handleSave(params = {}) {
      try {
        const submitData = {
          ...params,
          dataList: JSON.parse(JSON.stringify(this.tableData))
        };
        const res = await addOrUpdateFinanceEnvironmentChangeApi(submitData);
        if (res.status == 0) {
          this.$DonMessage.success("操作成功！");
          this.tableData = res.data;
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table_container {
  padding: 15px 18px 0 50px;
  .number_input {
    width: 100%;
    padding: 0;
    ::v-deep .el-input__inner {
      padding: 0 8px;
    }
  }
}
</style>
